import { ZoneTypes } from "../models/zones/ZoneModel";

const shapeOptions = {
  operationsZone: {
    strokeColor: "#000",
    strokeOpacity: 0.8,
    strokeWeight: 4,
    fillColor: "#607D8B",
    fillOpacity: 0.3,
    clickable: true,
    zIndex: 1,
  },
  preferredBikeReturnZone: {
    strokeColor: "#e9e623",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "#e9e623",
    fillOpacity: 0.5,
    clickable: true,
    zIndex: 2,
  },
  preferredBikeReturnZoneDisabled: {
    strokeColor: "#e95123",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "#e95123",
    fillOpacity: 0.5,
    clickable: true,
    zIndex: 2,
  },
  restrictedBikeReturnZone: {
    strokeColor: "#EF5350",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "#EF5350",
    fillOpacity: 0.5,
    clickable: true,
    zIndex: 2,
  },
  restrictedBikeReturnZoneDisabled: {
    strokeColor: "#C62828",
    strokeOpacity: 1,
    strokeWeight: 2,
    fillColor: "#C62828",
    fillOpacity: 0.5,
    clickable: true,
    zIndex: 2,
  },
};

const getShapeOptions = (zone) => {
  switch (zone.type) {
    case ZoneTypes.preferredBikeReturnZone.value:
      if (zone.visibility) {
        return shapeOptions.preferredBikeReturnZone;
      } else {
        return shapeOptions.preferredBikeReturnZoneDisabled;
      }
    case ZoneTypes.restrictedBikeReturnZone.value:
      if (zone.visibility) {
        return shapeOptions.restrictedBikeReturnZone;
      } else {
        return shapeOptions.restrictedBikeReturnZoneDisabled;
      }
    default:
      return shapeOptions[zone.type];
  }
};

export default getShapeOptions;
